export default __webpack_public_path__ + "static/media/EmptyFavoris.0535a578.svg";